<template>
  <div
    class="video-list"
    id="main-container"
    v-loading="loading"
    element-loading-text="拼命加载中"
    element-loading-spinner="el-icon-loading"
  >
    <div class="video-search">
      <el-input
        placeholder="请输入搜索关键字"
        v-model="searchinput"
        class="input-with-select"
        @keyup.enter.native="search"
      >
        <i slot="suffix" class="el-icon-search" @click="search"></i>
      </el-input>
    </div>
    <div class="video-container">
      <single-video
        :video="item"
        v-for="(item, index) in videoList"
        :key="index"
        @clickVideo="toVideo(item)"
      ></single-video>
    </div>
    <el-pagination
      background
      layout="jumper, prev, pager, next, slot, total"
      :total="total"
      :current-page="page"
      @current-change="currentChange"
      @prev-click="prevClick"
      @next-click="nextClick"
    >
      <!-- <span class="el-pagination__total"> 共 {{ pageCount }} 页，</span> -->
    </el-pagination>
  </div>
</template>

<script>
import SingleVideo from '../../components/common/SingleVideo.vue';
export default {
  components: {
    SingleVideo
  },
  data() {
    return {
      loading: false,
      total: 0,
      page: 1,
      videoList: [],
      searchinput: ''
    };
  },
  created() {
    this.getVideoList();
  },
  methods: {
    getVideoList(search) {
      this.loading = true;
      this.httpGet(this.$root.getVideo, {
        // class_id: this.$route.query.id,
        page: this.page,
        size: 12,
        title: search
      })
        .then(result => {
          if (result.count) {
            this.videoList.push(...result.data);
            this.total = Number(result.count);
          } else {
            this.videoList = [];
            this.total = 0;
          }
          this.$nextTick(() => {
            this.loading = false;
          });
        })
        .catch(err => {
          console.error('getVideoList-err', err);
        });
    },
    search() {
      this.page = 1;
      this.videoList = [];
      this.getVideoList(this.searchinput);
    },
    toVideo(item) {
      // 面包屑
      let breadObj = {
        id: item.id,
        path: 'article-list?id=' + item.id,
        name: item.title
      };
      this.$store.commit('setBreadArr', breadObj);
      this.$router.push({
        name: 'article-details',
        query: {
          id: item.id
        }
      });
    },

    currentChange(page) {
      console.log('currentChange', page);
      this.page = page;
      this.videoList = [];
      this.getVideoList();
    },
    prevClick(page) {
      console.log('currentChange1', page);
      this.page = page;
      this.videoList = [];
      this.getVideoList();
    },
    nextClick(page) {
      console.log('currentChange2', page);
      this.page = page;
      this.videoList = [];
      this.getVideoList();
    }
  },
  watch: {
    '$route.query.id': function(newValue, oldValue) {
      console.log('newValue, oldValue', newValue, oldValue);
      if (!this.loading && this.$route.name === 'video-list') {
        this.videoList = [];
        this.page = 1;
        this.total = 0;
        this.getVideoList();
      }
    }
  }
};
</script>

<style lang="stylus" rel="stylesheet/stylus" scoped>
@import '~assets/main.styl';

.video-list {
  width: 100%;
  // background: white;
  box-shadow: 0px -1px 0px 0px rgba(232, 232, 232, 1);
//   padding: 0 36px;
  box-sizing: border-box;
  margin-top: 15px;
}

.video-container {
  flex-x(flex-start,space-between);
  width: 100%;
  flex-wrap: wrap;
  height: 100%;
  margin-top: 20px;
}

>>>.el-pagination {
  flex-center();
  padding: 40px;
}

.video-search {
  padding-top: 20px;
  width: 40%;
  margin-left: 58%;

  >>>.el-input__inner {
    border-radius: 20px !important;
    background: white !important;
    color: #5084E4 !important;
  }

  .el-input__inner:-moz-placeholder {
    color: #5084E4 !important;
    opacity: 0.8;
  }

  .el-input__inner::-moz-placeholder {
    color: #5084E4 !important;
    opacity: 0.8;
  }

  .el-input__inner:-ms-input-placeholder {
    color: #5084E4 !important;
    opacity: 0.8;
  }

  >>>.el-input__inner::-webkit-input-placeholder {
    color: #5084E4 !important;
    opacity: 0.8;
  }

  >>>.el-input {
    width: 100%;
    height: 30px;
    background: rgba(255, 255, 255, 0.2);
    border-radius: 20px;
    color: white !important;

    .el-icon-search {
      position: relative;
      top: 40%;
      left: -40%;
      font-weight: 800;
      color: #4078DD;
      width: 21px;
      height: 21px;
    }
  }
}
</style>
